/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, TextField, FieldProps } from 'framework/ui/field';
import { updateCurrencyName } from 'framework/utils';

const LedgerAccountField = ({ source, ...props }: FieldProps) => {
  const { getValue } = useFieldHelper({ source });

  return <TextField {...props} source={source} value={updateCurrencyName(getValue())} />;
};

export default LedgerAccountField;
